/**
 * 物流管理 - 列表页面
 */

import React from 'react';
import { Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/Layout/PageHeader';
import { ChannelFilters } from './components/ChannelFilters';
import { ShippingRateTrendChart } from './components/ShippingRateTrendChart';
import { getChannelColumns } from './columns';
import { useChannels } from './hooks/useChannels';

export const ShippingManagement: React.FC = () => {
    const navigate = useNavigate();
    const { channels, loading, updateFilters, handleDelete } = useChannels();

    const columns = getChannelColumns(
        (id) => navigate(`/shipping-management/edit/${id}`),
        handleDelete
    );

    return (
        <div className="sku-management-page">
            <PageHeader
                title="物流管理"
                subtitle="管理不同国家/渠道的物流报价"
                actions={[
                    {
                        key: 'create',
                        label: '新建物流渠道',
                        type: 'primary',
                        icon: <PlusOutlined />,
                        onClick: () => navigate('/shipping-management/new'),
                    },
                ]}
            />

            <div className="sku-management-content">
                <ShippingRateTrendChart />

                <ChannelFilters onFilterChange={updateFilters} />

                <Table
                    columns={columns}
                    dataSource={channels}
                    loading={loading}
                    rowKey="id"
                    scroll={{ x: 1400 }}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showTotal: (total) => `共 ${total} 条`,
                    }}
                />
            </div>
        </div>
    );
};

export default ShippingManagement;
